var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";
import { Col, Row } from "reactstrap";
import euFlagIcon from "../../../assets/icons/logos/eu-flag.png";
import bgkIcon from "../../../assets/icons/logos/bgk.png";
import prowIcon from "../../../assets/icons/logos/prow.png";
import { LogosContainer, LogosIconsWrapper, LogosImg, LogosText } from "./Logos.styled";

var Logos = function Logos(props) {
  return React.createElement(LogosContainer, __assign({}, props), React.createElement(Row, null, React.createElement(Col, {
    sm: {
      size: 10,
      offset: 1
    },
    md: {
      size: 8,
      offset: 2
    }
  }, React.createElement(LogosIconsWrapper, null, React.createElement(LogosImg, {
    src: euFlagIcon,
    alt: ""
  }), React.createElement(LogosImg, {
    src: bgkIcon,
    alt: ""
  }), React.createElement(LogosImg, {
    src: prowIcon,
    alt: ""
  })))), React.createElement(Row, null, React.createElement(Col, {
    sm: {
      size: 10,
      offset: 1
    },
    md: {
      size: 8,
      offset: 2
    }
  }, React.createElement(LogosText, null, "Europejski Fundusz Rolny na rzecz Rozwoju Obszar\xF3w Wiejskich: Europa inwestuj\u0105ca w obszary wiejskie"))));
};

export default Logos;